import React, { useEffect, useState } from "react";
import "./users.css";
import httpService from "../../../services/http.service";
import Loader from "../../common/loader";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import UsersForm from "./usersform";
import "bootstrap/dist/css/bootstrap.min.css";
import { useLocation } from 'react-router-dom';
// import { bitStreamtoNumber, CHECK_KEYLOK } from "../../../config";
import SuccessMessage from "../../common/successMsg";
import ErrorMessage from "../../common/errorMsg";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

let UsersList = (props) => {
  const [content, setContent] = useState("list");
  const [form, setForm] = useState(<div></div>);
  const [loading, setLoading] = useState(false);
  const [hide] = useState(false)

  const [deleteUserModel, setdeleteUserModel] = useState(false);
  const [rowdata, setrowdata] = useState({});
  const [isDisable, setIsDisable] = useState(false);
  const toggleSetIdModal = () => setdeleteUserModel((prevState) => !prevState);
  let gridOptions = {};
  let onGridReady = {};
  function hideLoader() {
    setLoading(false);
  }

  const addUserClick = (event) => {
    event.preventDefault();
    props.addUserClick();
  };
  const location = useLocation();
  useEffect(() => {
    const userData = location.state?.content;
    if (userData == "list")
      setContent(userData)
  }, [location])

  const setField = (data) => {
    setContent("form");
    setForm(<UsersForm data={data} setformContent={setContent} loadAllData={props.loadAllData} />);
  };

  let DeleteUser = async (event, rowdata) => {
    event.preventDefault();
    toggleSetIdModal();
    setIsDisable(false)
    setrowdata(rowdata);
    hideLoader();
  };

  let ConfirmDelete = async () => {
    let confirm = window.confirm("Are you sure you want to delete this user!");
    if (confirm === false) {
      return;
    }
    let data = {
      id: rowdata._id,
    };
    let returnData = await httpService.getByBoj("DeleteUser", data).then((res) => res.data)
      .catch((err) => {
        if (err && err.response && err.response.status === 401) {
          ErrorMessage("Session expired, please login again")
        }
        return
      });
    props.loadAllData();
    if (returnData) {
      if (returnData.ack === "1") {
        SuccessMessage("User Deleted")
        setIsDisable(false)
      } else {
        ErrorMessage("Unable to delete user")
      }
    }
    toggleSetIdModal();
  }

  const Backupfordeleteuser = async (event, rowdata) => {
    let userID = rowdata._id;
    let userName = rowdata.customerId;
    let data = {
      userName: userName,
      userID: userID
    }
    try {
      await httpService.getByBoj(`createSingleUserBackup`, data)
        .then(async (data1) => {
          if (data1.data.ack === '1') {
            SuccessMessage("Backup created successfully")
            // ConfirmDelete()
            setIsDisable(true)
          }
        })
        .catch((err) => {
          if (err && err.response && err.response.status === 401) {
            ErrorMessage("Session expired, please login again")
          }
          return
        });

    }
    catch (err) {
      ErrorMessage('Something went wrong')
    }
  }
  const defaultColDef = {
    sortable: false,
    editable: false,
    flex: 1,
    filter: false,
  };

  const columns = [
    // {
    //   headerName: "User Name",
    //   field: "Username",
    //   cellRenderer: (params) => {
    //     var link = document.createElement("a");
    //     link.className = "linka";
    //     link.innerText = params.data.customerId;
    //     link.addEventListener("click", () => setField(params.data));
    //     // link.href = '/admin/distributordetail/' + params.data.orderitemid + "/" + params.data.sellersku
    //     return link;
    //   },
    // },
    {
      headerName: "User Name",
      field: "Username",
      cellRenderer: (params) => {
        const link = document.createElement("a");
        link.className = "linka";

        if (params.data.customerId === "Admin" || params.data.type === "admin") {
          link.innerText = params.data.customerId;
          link.style.color = "blue"; // Default color for non-expiring users
        } else {
          const expireDate = new Date(params.data?.endDate);
          const differenceInMilliseconds = expireDate.getTime() - new Date().getTime();
          const differenceInDays = Math.ceil(differenceInMilliseconds / (1000 * 3600 * 24));

          link.innerText = params.data.customerId;

          // Change the URL color based on the number of days left to expire
          if (differenceInDays <= 7) {
            link.style.color = 'red'; // 0 to 7 days: Red color
          } else if (differenceInDays <= 30) {
            link.style.color = 'orange'; // 8 to 30 days: Orange color
          } else if (differenceInDays <= 60) {
            link.style.color = 'blue'; // 30 to 60 days: Blue color
          } else {
            link.style.color = 'blue'; // Default color for more than 60 days
          }

        }
        link.addEventListener("click", () => setField(params.data));


        return link;
      },
    },

    {
      headerName: "User Type",
      field: "type",
      cellRenderer: (params) => {
        let span = document.createElement("div");
        if (params.data.customerId === "Admin" || params.data.type === "admin") {
          span.innerText = "Admin";
          // cloud user 
        } else if (params.data.type === "clouduser") {
          span.innerText = "Cloud User";
        }
        else if (params.data.type === "property_manager") {
          span.innerText = "Property Manager";
        }
        else if (params.data.type === "property_user") {
          span.innerText = "Property User";
        }
        else {
          span.innerText = "Property Name";
        }
        return span;
      },
    },
    {
      headerName: "Email",
      field: "email",
      cellRenderer: (params) => {
        var link = document.createElement("a");
        // if(!(params.data.email)){
        //   link.innerText = '--';
        // }
        link.innerText = params.data?.email ?? '--';
        return link;
      },
    },
    {
      headerName: "Account No.",
      field: "accountNo",
      cellRenderer: (params) => {
        let span = document.createElement("div");
        if (params.data.customerId === "Admin" || params.data.type === "admin") {
          span.innerText = "--";
        } else {
          span.innerText = params.data.accountNo;
        }
        return span;
      },
    },
    {
      headerName: "Phone",
      field: "mobileNo",
      cellRenderer: (params) => {
        let span = document.createElement("div");
        if (params.data.customerId === "Admin" || params.data.type === "admin") {
          span.innerText = "--";
        } else {
          span.innerText = params.data.mobileNo;
        }
        return span;
      },
    },
    {
      headerName: "Total Licence",
      field: "TotalLicence",
      cellRenderer: (params) => {
        let span = document.createElement("div");
        if (params.data.customerId === "Admin" || params.data.type === "admin") {
          span.innerText = "--";
        } else {
          span.innerText = params.data?.licenceNo ?? "--";
        }
        return span;
      },
    },
    {
      headerName: "RCC Cloud Space",
      field: "TotalLicence",
      cellRenderer: (params) => {
        let span = document.createElement("div");
        if (params.data.customerId === "Admin" || params.data.type === "admin") {
          span.innerText = "--";
        } else {
          span.innerText = `${params.data?.nasSpace} GB` ?? "--";
        }
        return span;
      },
    },
    {
      headerName: "Expire Date",
      field: "ExpireDate",
      cellRenderer: (params) => {
        let span = document.createElement("div");
        if (params.data.customerId === "Admin" || params.data.type === "admin") {
          span.innerText = "--";
        } else {
          span.innerText = params.data?.endDate ?? "--";
        }
        return span;
      },
    },
    {
      headerName: "Delete",
      suppressMenu: true,
      suppressSorting: true,
      cellRenderer: (params) => {
        let span = document.createElement("div");
        span.className = "spanname deleteUser";
        let img = document.createElement("i");
        img.className = "fa fa-trash delete-icon";
        img.hidden = params.data.customerId === "Admin" || params.data.type.toLowerCase() === "admin"
        img.onclick = (event) => DeleteUser(event, params.data);
        span.appendChild(img);
        return span;
      },
      onCellValueChanged: (params) => {
        let span = document.createElement("div");
        span.className = "spanname";
        let img = document.createElement("i");
        img.className = "fa fa-trash delete-icon";
        img.onclick = (event) => DeleteUser(event, params.data);
        span.appendChild(img);
        return span;
      },
      maxWidth: 100,
    }];

  return content === "list" ? (
    <>
      <div>
        {loading ? <Loader /> : null}
        <div className="pad-15">
          <div className="text-right">
            <button
              hidden={hide}
              className={"header-btn"}
              onClick={(event) => {
                if (!hide) addUserClick(event)
                else return
              }}
            >
              Add User
            </button>
            <div className="clear"></div>
          </div>
          <div className="form-boxdiv">
            <div className="form-boxtopline5">Users</div>
            <div className="form-boxtopcont user-form">
              <div
                className="ag-theme-alpine"
                style={{ height: "calc(100vh - 200px)", minHeight: "200px" }}
              >
                <AgGridReact
                  pagination={true}
                  paginationPageSize={20}
                  columnDefs={columns}
                  defaultColDef={defaultColDef}
                  enableBrowserTooltips={true}
                  tooltipShowDelay={{ tooltipShowDelay: 0 }}
                  rowData={props.usersList}
                  gridOptions={gridOptions}
                  gridReady={onGridReady}
                  getRowStyle={(params) => {
                    if (params.data.type !== 'clouduser') {
                      return {}; // Return empty object for rows that are not 'clouduser'
                    }
                    // console.log(params.data,"asdfghjkl")
                    const endDate = new Date(params.data.endDate);
                    const currentDate = new Date();
                    const differenceInMilliseconds = endDate.getTime() - currentDate.getTime();
                    const differenceInDays = Math.ceil(differenceInMilliseconds / (1000 * 3600 * 24));

                    let backgroundColor = '';

                    if (differenceInDays <= 7) {
                      backgroundColor = '#f3cbbd'; // 0 to 7 days: Red color
                    } else if (differenceInDays <= 30) {
                      backgroundColor = '#fff6b4'; // 8 to 30 days: Yellow color
                    } else if (differenceInDays <= 60) {
                      backgroundColor = '#e7feff '; // 30 to 60 days: Blue color
                    }

                    return { backgroundColor };
                  }}
                ></AgGridReact>
                <Modal
                  isOpen={deleteUserModel}
                  toggle={toggleSetIdModal}
                  size="md"
                  centered={true}
                >
                  <ModalHeader toggle={toggleSetIdModal}>{"Alert!"}</ModalHeader>
                  <ModalBody>
                    <label>Please create a backup before deleting " {rowdata.customerId} " User</label>
                  </ModalBody>
                  <ModalFooter>
                    <div className="">
                      <Button
                        color="success"
                        style={{ marginRight: "5px" }}
                        onClick={(event) => {
                          Backupfordeleteuser(event, rowdata);
                        }}
                        disabled={isDisable}
                      >Backup
                      </Button>
                      <Button
                        color="danger"
                        onClick={() => {
                          ConfirmDelete();
                        }}
                      >
                        Delete
                      </Button>
                    </div>
                  </ModalFooter>
                </Modal>

              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  ) : (
    form
  );
};

export default UsersList;
